const API_BASE_URL = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? ''
const FUNCTIONS_BASE = `${API_BASE_URL}/.netlify/functions`

const fetchJSON = async (path) => {
  const url = path.startsWith('http') ? path : `${FUNCTIONS_BASE}${path}`
  const response = await fetch(url)
  const contentType = response.headers.get('content-type') || ''
  const text = await response.text()

  if (!response.ok) {
    throw new Error(text || `Request failed (${response.status})`)
  }

  if (!contentType.includes('application/json')) {
    throw new Error(
      'Unexpected response when loading data. If you are running locally use `netlify dev` so functions are available.',
    )
  }

  const payload = JSON.parse(text || '{}')
  return payload.data ?? payload
}

const buildQueryString = (params = {}) => {
  const search = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    search.set(key, typeof value === 'boolean' ? (value ? 'true' : 'false') : String(value))
  })
  return search.toString()
}

export const fetchProperties = async (params = {}) => {
  const query = buildQueryString({ full: true, ...params })
  return fetchJSON(`/properties?${query}`)
}

export const fetchProperty = async (id) => fetchJSON(`/property?id=${encodeURIComponent(id)}`)
